module.exports = __webpack_public_path__ + "static/fetch-ruffcut-blackmuzzle-5bafa78a0e2b402d9ba38fd81cc6c83a.webm";